import React from 'react'
import { Action, IOWidget, mk_widget } from 'widgets-for-react'
import { ButtonData } from '../../../../wordpress/types_and_parser/extra_types.mod'
import { CMSState } from '../../../../cms/blocks/types.gen'
import { link, linkWrapper } from '../../../../cms/blocks/utils.gen'
import { t } from 'i18next'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { useState } from 'react'

export type TextBlockProps<CustomBlockData, extra_images> = {
  title?: string
  text: string
  primary_button?: ButtonData
  secondary_button?: ButtonData
  has_show_more: boolean
}

export type TextBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  content_classname: string
  text_classname: string
  footer_classname: string
  clickable_primary_classname: string
  clickable_secondary_classname: string
}>

export function TextBlock<CustomBlockData, extra_images>(
  props: TextBlockProps<CustomBlockData, extra_images>,
  options?: { style?: TextBlockStyle; key?: string }
): IOWidget<CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>, Action<CMSState<CustomBlockData, extra_images, never>>> {
  return (s: CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>) =>
    mk_widget({
      run: onDone => (
        <TextBlockComponent textProps={props} options={options} cmssState={s} />
      )
    })
}

type Props<CustomBlockData, extra_images> = {
  textProps: TextBlockProps<CustomBlockData, extra_images>
  options: { style?: TextBlockStyle; key?: string }
  cmssState: CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>
}

function TextBlockComponent<CustomBlockData, extra_images>(props: Props<CustomBlockData, extra_images>) {
  const [expanded, setExpanded] = useState(false)

  return (
    <section
      className={`block block--text block--light${props.textProps.has_show_more ? (` block--show${expanded ? ' block--expanded' : ' block--expandable'}`) : ''} container--s`}
      key={props.options && props.options.key ? props.options.key : 'text-block'}
    >
      <div className="block__inner grid--block">
      {props.textProps.title &&
        <header className="block__header">
          <h2 className="block__title typo--xl">{props.textProps.title}</h2>
        </header>
      }

        <div className="block__content">
          <div
            className="block__text text--styled"
            dangerouslySetInnerHTML={{ __html: props.textProps.text }}
          />
        </div>

        {props.textProps.has_show_more &&
          <div className="block__action">
            { expanded
              ? <button
                  className="button button--toggler button--toggler--open"
                  onClick={_ => {
                    setExpanded(false)}
                }>{ t('show_button.less') }</button>
              : <button
                  className="button button--toggler"
                  onClick={_ => {
                    window.dataLayer.push({
                      event: "event.dubbeldam", category: "Interaction", action: "Show more", label: window.location.pathname
                    });
                    setExpanded(true)}
                }>{ t('show_button.more') }</button>
            }
          </div>
        }

        {(props.textProps.primary_button || props.textProps.secondary_button) && (
          <footer className="block__footer">
            {props.textProps.primary_button && (
              link(linkWrapper({title:props.textProps.primary_button.text,url:props.textProps.primary_button.url}),
                { classname: 'button button--primary' },
                props.textProps.primary_button.text,
                () => {
                  window.dataLayer.push({
                    event: 'event.dubbeldam',
                    category: 'TextBlock',
                    action: props.textProps.primary_button.text,
                    label: window.location.pathname,
                  })
                }
              )
            )}
            {props.textProps.secondary_button && (
              link(linkWrapper({title:props.textProps.secondary_button.text,url:props.textProps.secondary_button.url}),
                { classname: 'link link--primary' },
                props.textProps.secondary_button.text,
                () => {
                  window.dataLayer.push({
                    event: 'event.dubbeldam',
                    category: 'TextBlock',
                    action: props.textProps.secondary_button.text,
                    label: window.location.pathname,
                  })
                }
              )
            )}
          </footer>
        )}
      </div>
    </section>
  )
}